import { CreateModifyBase } from "./base/CreateModifyBase";
import { FaultLogComment } from "./FaultLogComment";

export interface FaultLog extends CreateModifyBase {
  id: number;
  numOfDeliveries?: number[];
  acknowledged?: boolean;
  acknowledgedBy?: string;
  acknowledgedTime?: Date;
  assetName?: string[];
  closedDate?: Date;
  country?: string;
  customerFlag?: string[];
  customerName?: string[];
  customerCity?: string[];
  customerStateCode?: string[];
  customerShipTo?: string[];
  customerDemandType?: string[];
  customerPostCode?: string[];
  deviceId?: string[];
  deviceType?: string[];
  devicePic?: string[];
  faultCode?: string;
  status?: string;
  impactOnLogistics?: string;
  priority?: string;
  product?: string[];
  terminal?: string[];
  owner?: string;
  region?: string;
  reportedBy?: string;
  reportedTime?: Date;
  rootCause?: string;
  sapNotificationNumber?: number;
  siteVisitDate?: Date;
  telemetrySystem?: string;
  toEngineeringDate?: Date;
  isSendLogistics?: boolean;
  isSpontaneouslyRecovered?: boolean;
  isSpontaneouslyRecoveredViewed?: boolean;
  vesselId?: string[];
  workOrderNumber?: string;
  workOrderUserStatus?: string;
  workOrderSystemStatus?: string;
  workOrderSystemStatusDesc?: string;
  workOrderUserStatusDesc?: string;
  notificationStatusDesc?: string;
  workOrderLongText?: string;
  lastCreateSapNotifyMessage?: string;
  workOrderInstructions: string;
  notifyNumber: number;

  latestComments?: string;
  combinedComments?: string;
  comments: FaultLogComment[];

  needAck?: boolean;
  isFlashing?: boolean;
  FlashingColor?: string;
  domain?: string;
}

export interface SapSyncStatusResult {
  workOrderNumber?: string;
  sapNotificationNumber?: string;
  workOrderLongText?: string;
  workOrderUserStatus?: string;
  workOrderSystemStatus?: string;
  workOrderUserStatusDesc?: string;
  workOrderSystemStatusDesc?: string;
  notificationStatusDesc?: string;
}

export function UpdateFaultLogLatestComments(faultLogs: FaultLog[]) {
  if (!faultLogs) {
    return;
  }

  faultLogs.forEach((faultLog) => {
    if (!faultLog || !faultLog.comments || faultLog.comments.length === 0) {
      return;
    }

    faultLog.latestComments = faultLog.comments[faultLog.comments.length - 1].comments;
  });
}

export function GetFaultLogCombinedComments(faultLog: FaultLog): string {
  if (!faultLog || !faultLog.comments || faultLog.comments.length === 0) {
    return "";
  }

  return faultLog.comments
    .map((comment) => {
      const createdAt = comment.createdAt ? new Date(comment.createdAt).toLocaleString() : "";
      return `${comment.createUser} ${createdAt} ~ ${comment.comments}\n`;
    })
    .join("\n");
}
